export default "__VITE_ASSET__BzuUM8CR__"